/** The next session piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { NextSessionEvents } from './contract';
import { NextSessionView } from './NextSessionView';
import { useNextSession } from './useNextSession';

export { NextSessionView, useNextSession };

export function NextSession(props: PieceInput<NextSessionEvents>) {
  return <NextSessionView {...useNextSession(props)} />;
}
